export default __webpack_public_path__ + "static/media/PROVIMENTO-112-2006.7a53aef8.pdf";